import { render, staticRenderFns } from "./pickList.vue?vue&type=template&id=bc3a439e&scoped=true&"
import script from "./pickList.vue?vue&type=script&lang=js&"
export * from "./pickList.vue?vue&type=script&lang=js&"
import style0 from "./pickList.vue?vue&type=style&index=0&id=bc3a439e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc3a439e",
  null
  
)

export default component.exports